module.exports = __webpack_public_path__ + "img/SR_ICON_Management.51ded221.svg";